import React from "react";
import PoolInfoGrid from "./PoolInfoGrid";

const PoolInfoSection = ({ villa }) => {
  return (
    <div className="flex md:flex-row flex-col md:gap-0 gap-3 items-start lg:pb-[50px] md:pb-7 pb-4 border-b border-[#E7EDF4] lg:mb-12 md:mb-6 mb-3">
      <div className="w-full md:w-1/5">
        <span className="text-xl font-medium leading-normal text-themeBlack">
          Havuz Bilgisi
        </span>
      </div>
      <div className="w-full md:w-4/5">
        <PoolInfoGrid villa={villa} />
      </div>
    </div>
  );
};

export default PoolInfoSection;
